import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';

import { fmtDate } from './railcarUtil';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	IconButton,
} from '@material-ui/core';

const formatNumIntl = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 0,
}).format;

function formatNum(val) {
	if (_.isNull(val)) {
		return '-';
	}
	return formatNumIntl(val);
}

export const GAIN_MAX = 250;
export const LOSS_MIN = -250;

// Shared between the quick filter and the row highlight so they always agree
export function legMatchesSearchString(leg, searchLower) {
	if (leg.bol && leg.bol.toLowerCase().includes(searchLower)) {
		return true;
	}
	if (leg.stationDeliveryId && leg.stationDeliveryId.toString().includes(searchLower)) {
		return true;
	}
	if (leg.bulkDeliveryId && leg.bulkDeliveryId.toString().includes(searchLower)) {
		return true;
	}
	return false;
}

function formatGainLoss(railcar, showRemaining, isUnion) {
	const { gainLoss, gainLossSimulated } = railcar;

	let railcarCount = 1;
	if (isUnion) {
		railcarCount = railcar.railcars ? railcar.railcars.length : 1;
	}

	const val = formatNum(
		showRemaining ? (gainLossSimulated === 0 ? gainLossSimulated : -gainLossSimulated) : gainLoss
	);
	if (showRemaining) {
		return val;
	}

	const color =
		gainLoss > GAIN_MAX * railcarCount || gainLoss < LOSS_MIN * railcarCount ? 'red' : 'black';
	return <div style={{ color }}>{val}</div>;
}

const deliveryColumns = [
	{
		sortId: 'stationDeliveryId',
		displayId: 'stationDeliveryIdLink',
		label: 'Order #',
	},
	{
		sortId: 'typeDisplay',
		displayId: 'typeDisplay',
		label: 'Type',
	},
	{
		sortId: 'deliverySortId',
		displayId: 'deliveryDateFormatted',
		label: 'Date',
	},
	{
		sortId: 'deliveryWindow',
		displayId: 'deliveryWindow',
		label: 'Window',
	},

	{
		sortId: 'carrierDisplay',
		displayId: 'carrierDisplay',
		label: 'Carrier',
	},
	{
		sortId: 'customerDisplay',
		displayId: 'customerDisplay',
		label: 'Customer',
	},
	{
		sortId: 'scheduledGallons',
		displayId: 'scheduledGallonsDisplay',
		label: 'Schd. Gals',
	},
	{
		sortId: 'netGallons',
		displayId: 'netGallonsDisplay',
		label: 'Net Gals',
	},
	{
		sortId: 'grossGallons',
		displayId: 'grossGallonsDisplay',
		label: 'Gross Gals',
	},
	{
		sortId: 'bol',
		displayId: 'bolDisplay',
		label: 'BOL',
	},
	{
		sortId: 'grossGallonsDisplay',
		displayId: 'updateButton',
		label: 'Link',
	},
];

export class RailcarUnion extends Component {
	render() {
		const {
			classes,
			railcarUnion,
			copyToClipboard,
			showRemaining,
			highlightEmpty,
			quickFilterPoMonth,
			quickFilter,
		} = this.props;

		const filterStyle = {
			backgroundColor: '#fff13b',
			padding: '2px 4px',
			borderRadius: '4px',
		};
		const isRelinquished = _.some(railcarUnion.railcars, 'relinquishedDate');
		const moreThanOneRailcar = railcarUnion.railcars.length > 1;
		const railcarIds = _.map(railcarUnion.railcars, 'railcarId');

		return (
			<Accordion
				width="100%"
				defaultExpanded={isRelinquished ? false : true}
				style={{ background: 'white' }}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<div style={{ width: '100%' }}>
						<div
							style={{
								opacity: 1,
								width: '100%',
								padding: '0px 0px',
								display: 'grid',
								gridTemplateColumns: '3fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
							}}
						>
							<div style={{ display: 'flex' }}>
								<div className={classes.oilTanker} />
								{moreThanOneRailcar && (
									<>
										<div className={classes.connector}>
											<div className={classes.dotLeft}></div>
											<div className={classes.line}></div>
											<div className={classes.dotRight}></div>
										</div>
										<div className={classes.oilTanker} />
									</>
								)}
								<div>{railcarUnion.terminalDisplay}</div>

								{moreThanOneRailcar && (
									<Button
										variant="outlined"
										color="primary"
										className={classes.unlinkDeliveriesButton}
										style={{ marginLeft: 5 }}
										size="small"
										onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
											this.props.handleOpenUnlinkDialog(railcarIds);
										}}
									>
										Unlink
									</Button>
								)}
							</div>
						</div>

						<table style={{ width: '100%' }}>
							<tbody>
								{railcarUnion.railcars.map((railcar) => {
									let mtDate = fmtDate(railcar.emptyDate);
									let emptyDateDisplay = mtDate;
									if (highlightEmpty && railcar.emptyDate) {
										emptyDateDisplay = (
											<div
												style={{ padding: '2px', borderRadius: '3px', backgroundColor: '#FBE9E7' }}
											>
												{mtDate}
											</div>
										);
									}

									return (
										<tr
											key={railcar.railcarId}
											style={{
												opacity: 1,
												width: '100%',
												color: '#666',
												padding: '0px 0px',
												// display: 'grid',
												// gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
											}}
										>
											<td className={classes.accordionHeader}>
												<div style={{ display: 'flex' }}>
													<div>
														<div className={classes.headerLabel}>Railcar #:</div>
														<div
															className={classes.headerValue}
															style={{ fontWeight: 'bold', fontSize: '14px', display: 'flex' }}
														>
															{railcar.railcarNumber || '-'}

															<IconButton
																size="small"
																fontSize="9px"
																style={{ marginTop: '-3px', color: '#333' }}
																onClick={(e) => {
																	e.stopPropagation(); // This stops the event from bubbling up
																	copyToClipboard(railcar.railcarNumber || '-');
																}}
															>
																<CopyIcon style={{ height: 16 }} />
															</IconButton>
														</div>
													</div>
												</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Supplier:</div>
												<div className={classes.headerValue} style={{ fontSize: '75%' }}>
													{railcar.supplierDisplay || '-'}
												</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Product:</div>
												<div className={classes.headerValue}>{railcar.productDisplay || '-'}</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>PO #:</div>
												<div
													className={classes.headerValue}
													style={quickFilterPoMonth ? filterStyle : {}}
												>
													{railcar.requestedMonthNumberDisplay || '-'}
												</div>
											</td>
											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>FMP Contract ID</div>
												<div className={classes.headerValue}>
													{railcar.fuelContractId ? (
														railcar.fuelContractId
													) : (
														<span style={{ color: '#c00' }}><span role="img" aria-label="warning">⚠️</span> Missing</span>
													)}
												</div>
											</td>
											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>CP Date</div>
												<div className={classes.headerValue}>{fmtDate(railcar.cpDate)}</div>
											</td>
											{railcar.apDate ? (
												<td className={classes.accordionHeader}>
													<div className={classes.headerLabel}>Date Rec&apos;d:</div>
													<div className={classes.headerValue}>{fmtDate(railcar.apDate)}</div>
												</td>
											) : (
												<td className={classes.accordionHeader}>
													<div className={classes.headerLabel}>ETA Date:</div>
													<div className={classes.headerValue}>{fmtDate(railcar.etaDate)}</div>
												</td>
											)}

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Date Empty</div>
												<div className={classes.headerValue}>{emptyDateDisplay}</div>
											</td>
											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Date Rel:</div>
												<div className={classes.headerValue}>
													{fmtDate(railcar.relinquishedDate)}
												</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Net Gal</div>
												<div className={classes.headerValue}>{formatNum(railcar.netGallons)}</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Gross Gal</div>
												<div className={classes.headerValue}>{formatNum(railcar.grossGallons)}</div>
											</td>

											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>Gals Out</div>
												<div className={classes.headerValue}>
													{formatNum(railcar.netGallonsOutForTimeFrame)}
													<span style={{ fontSize: '75%', color: '#999', marginLeft: 3 }}>
														({formatNum(railcar.netGallonsOut)})
													</span>
												</div>
											</td>
											<td className={classes.accordionHeader}>
												<div className={classes.headerLabel}>
													{showRemaining ? 'Alloc Rem' : 'Gain/Loss'}
												</div>
												<div className={classes.headerValue}>
													{formatGainLoss(railcar, showRemaining)}
												</div>
											</td>
										</tr>
									);
								})}

								{moreThanOneRailcar && (
									<tr
										style={{
											opacity: 1,
											width: '100%',
											color: '#666',
											padding: '0px 0px',
											paddingTop: '3px',
											marginTop: '3px',
											borderTop: '1px solid #ddd',
										}}
									>
										<td colSpan={9}></td>
										<td className={classes.accordionHeader}>
											<div className={classes.headerLabel}>Net Gal</div>
											<div className={classes.headerValue}>
												{formatNum(railcarUnion.netGallons)}
											</div>
										</td>

										<td className={classes.accordionHeader}>
											<div className={classes.headerLabel}>Gross Gal</div>
											<div className={classes.headerValue}>
												{formatNum(railcarUnion.grossGallons)}
											</div>
										</td>

										<td className={classes.accordionHeader}>
											<div className={classes.headerLabel}>Gals Out</div>
											<div className={classes.headerValue}>
												{formatNum(railcarUnion.netGallonsOutForTimeFrame)}
												<span style={{ fontSize: '75%', color: '#999', marginLeft: 3 }}>
													({formatNum(railcarUnion.netGallonsOut)})
												</span>
											</div>
										</td>
										<td className={classes.accordionHeader}>
											<div className={classes.headerLabel}>
												{showRemaining ? 'Alloc Rem' : 'Gain/Loss'}
											</div>
											<div className={classes.headerValue}>
												{formatGainLoss(railcarUnion, showRemaining, true)}
											</div>
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					{_.isEmpty(railcarUnion.allDeliveryLegs) ? (
						<div style={{ fontStyle: 'italic', color: '#888', fontSize: '80%' }}>
							No deliveries associated
						</div>
					) : (
						<div
							style={{
								width: '100%',
								border: '1px solid #ddd',
								borderRadius: '5px',
								overflow: 'hidden',
							}}
						>
							<TableContainer style={{ overflowX: 'initial' }}>
								<Table stickyHeader size={'small'} aria-label="enhanced table">
									<TableHead>
										<TableRow style={{ whiteSpace: 'nowrap', height: '32px' }}>
											{deliveryColumns.map((column) => {
												const columnLabel = column.label;
												return (
													<TableCell
														key={column.sortId}
														align={column.numeric ? 'right' : 'left'}
														padding={column.disablePadding ? 'none' : 'default'}
														style={column.style}
													>
														{columnLabel}
													</TableCell>
												);
											})}
										</TableRow>
									</TableHead>

									<TableBody>
										{railcarUnion.allDeliveryLegs.map((row, i) => {
											const isFilterMatch = quickFilter && legMatchesSearchString(row, quickFilter);
											return (
												<TableRow
													key={`${row.railcarId}_${i}`}
													hover
													role="checkbox"
													tabIndex={-1}
													style={{
														height: '32px',
														backgroundColor: isFilterMatch ? '#fff59d' : undefined,
													}}
												>
													{deliveryColumns.map(({ displayId }) => {
														return <TableCell key={displayId}>{row[displayId]}</TableCell>;
													})}
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
					)}
				</AccordionDetails>
			</Accordion>
		);
	}
}

RailcarUnion.propTypes = {
	classes: PropTypes.object.isRequired,
	railcarUnion: PropTypes.object.isRequired,
	copyToClipboard: PropTypes.func.isRequired,
	handleOpenUnlinkDialog: PropTypes.func.isRequired,
	showRemaining: PropTypes.bool,
	highlightEmpty: PropTypes.bool,
	quickFilterPoMonth: PropTypes.string,
	quickFilter: PropTypes.string,
};
